import { AgentDiscovery } from '@bty/business-components'
import { memo } from 'react'

export const Discovery = memo(() => {
  return <AgentDiscovery />
})
